export const drawToolCheckboxName = 'draw';
export const drawEllipseToolCheckboxName = 'draw-ellips';
export const drawRectangleToolCheckboxName = 'draw-rectangle';
export const colorPipetteToolCheckboxName = 'color-pipette';
export const cropToolCheckboxName = 'crop';
export const commentToolTextAreaName = 'comment';
export const customStoreyToolName = 'custom-storey';

export const cropRectangleColor = '#F0F';
export const storeyRectangleColor = '#847';
export const storeyMarkerColor = '#8EE';
export const selectedStoreyMarkerColor = '#FF6';

export const cropRectangleName = 'cropRect';
export const canvasObjectPropertyName = 'canvasObject';

export const symbolClassName = 'annotation-symbol';
export const commentClassName = 'annotation-comment';

export const textPanelItemClassName = 'annotation-text-panel-item';

export const fontSizeToolChange = 'annotation-toolbar-font-size-changer';
export const trashButton = 'annotation-toolbar-trash-button';

export const strokeWidthToolChange = 'annotation-toolbar-stroke-width-changer';
export const strokeColorToolChange = 'annotation-toolbar-stroke-color-changer';
export const strokeOpacityToolChange = 'annotation-toolbar-stroke-opacity-changer';

export const rotateFreelyName = 'annotation-toolbar-rotate-freely-changer';
